import plugin from 'tailwindcss/plugin';

import { pxTorem } from './helpers.js';


const expandInteractions = plugin(({ addComponents, e }) => {
    addComponents([
        {
            [`.${e('expand-interaction')}`]: {
                position: 'relative'
            },
            [`.${e('expand-interaction')} .${e('expand-interaction__action')}::before`]: {
                '@apply inset-0 absolute block': {},
                content: '" "',
                zIndex: 1
            },
            [`.${e('expand-interaction')} a:not(.${e('expand-interaction__action')}),
                .${e('expand-interaction')} button:not(.${e('expand-interaction__action')})
            `]: {
                'position': 'relative',
                zIndex: 2
            }
        }
    ]);
});


const typeStyles = plugin(({ addComponents, theme, e }) => {
    const screens = Object.keys(theme('screens'));

    // Form all breakpoints into an array
    const values = Object.entries(theme('typeStyles')).reduce((pV, [key, value]) => {
        const breakpoints = Object.entries(value).filter(([v]) => screens.includes(v));
        return {
            ...pV,
            [key]: {
                ...value,
                breakpoints
            }
        };
    }, {});

    const baseStyles = {
        fontFamily: 'var(--tw-type--family)',
        fontWeight: 'var(--tw-type--weight, normal)',
        fontSize: 'var(--tw-type--size, 16px)',
        lineHeight: 'var(--tw-type--line-height, 1)',
        letterSpacing: 'var(--tw-type--letter-spacing, 0px)',
        textTransform: 'var(--tw-type--text-transform, none)',
        fontFeatureSettings: 'var(--tw-type--font-feature-settings, normal)'
    };

    const baseSelectors = Object.entries(values)
        .map(([key, _value]) => {
            return `.${e(`type-style-${key}`)}`;
        })
        .join(',\n');

    const toFontFamily = (ff) => {
        if (typeof ff === 'string') {
            return ff;
        } else if (Array.isArray(ff) && ff?.length > 0) {
            return ff.join(',');
        }
    };

    const toPixelSize = (fs) => {
        if (typeof fs === 'number') {
            return `${pxTorem(fs)}rem`;
        } else {
            return fs;
        }
    };

    const mapToVariables = (value) => ({
        ...(value?.fontFamily && { '--tw-type--family': toFontFamily(value.fontFamily) }),
        ...(value?.fontWeight && { '--tw-type--weight': `${value.fontWeight}` }),
        ...(value?.fontSize && { '--tw-type--size': toPixelSize(value.fontSize) }),
        ...(value?.lineHeight && { '--tw-type--line-height': toPixelSize(value.lineHeight) }),
        ...(value?.letterSpacing && { '--tw-type--letter-spacing': toPixelSize(value?.letterSpacing) }),
        '--tw-type--text-transform': value.textTransform ?? 'none',
        '--tw-type--font-feature-settings': value.fontFeatureSettings ?? 'normal',
        ...(value.apply && { [`@apply ${value.apply}`]: '' }),
    });

    // Create classes
    addComponents([
        {
            [baseSelectors]: baseStyles,
        },
        Object.entries(values).map(([key, value]) => {
            return {
                [`.${e(`type-style-${key}`)}`]: {
                    ...mapToVariables(value),
                    // Process breakpoints if has any
                    ...(value?.breakpoints && value.breakpoints.reduce((pV, [bpKey, bpValue]) => {
                        return {
                            ...pV,
                            [`@screen ${bpKey}`]: mapToVariables(bpValue)
                        };
                    }, {}))
                }
            };
        }),
        {
            '.no-scrollbar': {
                'scrollbar-width': 'none',         // Firefox
                '-ms-overflow-style': 'none',      // IE 10+
            },
            '.no-scrollbar::-webkit-scrollbar': {
                display: 'none',                   // Chrome, Safari
            },
        }
    ]);
});


export {
    expandInteractions,
    typeStyles
};
